var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.activeApiCalls>0)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.spinnerColor,"size":"35","width":"5"}},[_vm._v(_vm._s(_vm.activeApiCalls))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }